import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const webAdministrationRoutes: MenuInterface[] = [
    {
        code: 'Module_PortailOptionsGenerales',
        route: [
            {
                content: 'web-administration/general-options',
                focus: 'web-administration/general-options/informations',
            }, 'content'
        ]
    },
    {
        code: 'Module_PortailMenus',
        route: [
            {
                content: 'web-administration/editorial/list',
                focus: 'web-administration/editorial/informations'
            }, 'content'
        ]
    },
    {
        code: 'Module_PortailPortlets',
        route: [{
            content: 'web-administration/home',
            focus: 'empty'
        }, 'content'
        ]
    },
    {
        code: 'GestionModerationCommentaires_ViewModel',
        route: [
            {
                content: 'web-administration/comments-moderation/list',
                focus: 'web-administration/comments-moderation/informations',
            }, 'content'
        ]
    },
    {
        code: 'Module_PortailTrombinoscope',
        route: [
            {
                content: 'web-administration/trombinoscope',
                focus: 'web-administration/trombinoscope/detail',
            }, 'content'
        ]
    },
    {
        code: 'GestionHistoriqueSalarie_ViewModel',
        route: [
            {
                content: 'web-administration/beneficiary-history-settings',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionAdminDirectoParamFicheProfil_ViewModel',
        route: [
            {
                content: 'web-administration/online-services/profile-card',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'Module_PortailGED_Albums',
        route: [
            {
                content: 'web-administration/documentary-management/records/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ]
    },
    {
        code: 'Module_PortailGED_Documents',
        route: [
            {
                content: 'web-administration/documentary-management/documents/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ]
    }
];
